import { render, staticRenderFns } from "./CNSupport.vue?vue&type=template&id=69ee9a4f&scoped=true"
import script from "./CNSupport.vue?vue&type=script&lang=js"
export * from "./CNSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ee9a4f",
  null
  
)

export default component.exports